import Vue from "vue";
import LoginPage from "./LoginPage.vue";
import textFieldVue from "../../components/v-components/input-text.vue";
import select2 from "../../components/v-components/plugins/select2.vue";
import modal from "../../components/v-components/modal.vue";
import ConfirmationDialog from "../../components/v-components/confirmation-dialog.vue";
import ErrorDialog from "../../components/v-components/error-dialog.vue";
import VSelect from "../../components/v-components/vue-select2/VSelect2.vue";
import 'vue-select/dist/vue-select.css';
import phoneFieldVue from "../../components/v-components/vPhoneInput.vue";
import CodeInput from "vue-verification-code-input";

Vue.use(require('vue-moment'));
Vue.component("v-input-text", textFieldVue);
Vue.component("select2", select2);
Vue.component("v-modal", modal);
Vue.component('v-select', VSelect);
Vue.component("code-input", CodeInput);
Vue.component('v-phone-number-input', phoneFieldVue);
Vue.component('confirmation-dialog', ConfirmationDialog);
Vue.component('error-dialog', ErrorDialog);

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                binding.value(event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});
Vue.prototype.$eventBus = new Vue();

new Vue({
    el: "#vue-login-page",
    components: {
        LoginPage,
    },
});



// WEBPACK FOOTER //
// ./modules/login-page/index.js